import React from 'react'
import { Edit, required, SimpleForm, TextInput, useNotify, useRedirect, useTranslate } from 'react-admin'
import { Grid } from '@mui/material'
import { CardCommon } from 'src/components/uiElements'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { CardCrudBottomButtons } from 'src/components/uiElements/CRUD/CardCrudBottomButtons'

export const TypeResponsibleEdit = (props) => {
  const translate = useTranslate()
  const notify = useNotify()
  const redirect = useRedirect()

  const onSuccess = () => {
    notify('ra.notification.updated_success_femenine', {
      type: 'success',
      messageArgs: { element: translate('ra.single_entity.type_responsible') }
    })
    redirect('/type-responsible')
  }

  const onError = () => {
    notify('ra.notification.updated_error_femenine', {
      type: 'error',
      messageArgs: { element: translate('ra.single_entity.type_responsible') }
    })
  }

  return (
    <Edit {...props} mutationMode='pessimistic' mutationOptions={{ onSuccess, onError }} actions={null}>
      <CardCommon title={translate('ra.title.update_type_responsible')}>
        <SimpleForm toolbar={<CardCrudBottomButtons btnSave={true} btnDelete={true} fieldsName={['name']} genderElement='femenine' />}>
          <Grid container spacing={3}>
            <EditInputsWrap label={translate('ra.field.id')}>
              <TextInput disabled source='id' label={false} fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.name')} required>
              <TextInput source='name' label={false} fullWidth validate={[required()]} />
            </EditInputsWrap>
          </Grid>
        </SimpleForm>
      </CardCommon>
    </Edit>
  )
}
